import Header from './../../../components/Header/BarOther.vue';
import FooterOther from './../../../components/Footer/FooterOther.vue';
import { Message } from 'element-ui';

import api from '../../../api.js';
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
const axios = require('axios');
export default {
  name: 'mainww',
  components: { Header, FooterOther },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  data() {
    // 验证邮箱的规则
    var checkEmail = (rule, value, cb) => {
      //  验证邮箱的正则表达式
      const regEmail = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (regEmail.test(value)) {
        // 合法邮箱
        return cb();
      }
      cb(new Error('Please input a valid email address'));
    };
    return {
      info: {
        name: '',
        email: '',
        msg: '',
      },
      isShow:false,
      rules: {
        name: [{ required: true, message: 'required', trigger: 'blur' }],
        email: [
          { required: true, message: 'required', trigger: 'blur' },
          { validator: checkEmail, trigger: 'blur' },
        ],
        msg: [{ required: true, message: 'required', trigger: 'blur' }],
      },
    };
  },
  mounted() {},
  methods: {
    submit() {
      var that = this
      that.$refs['form'].validate((valid) => {
        if (valid) {
          axios
            .get(
              api.savePersonMsg +
                '?personName=' +
                that.info.name +
                '&personEmail=' +
                that.info.email +
                '&personContent=' +
                that.info.msg,
            )

            .then(function (res) {
              console.log(res);
              if (
                res.data.code == 200 &&
                res.data.data.personMessage == '发送成功'
              ) {
                // Message({ message: '发送成功！', type: 'success' });
                that.isShow = true
                setTimeout(function(){
                  that.isShow = false
                },2000)
                return;
              } else {
                Message.error('操作失败！请重试');
                return;
              }
            })
            
        } else {
          return false;
        }
      });
      // if(!this.info.email) return Message({message: '请输入邮箱！',type: 'warning'});
      // if(!this.info.name) return Message({message: '请输入姓名！',type: 'warning'});
      // if(!this.info.msg) return Message({message: '请输入内容！',type: 'warning'});
    },
    swiperchange(i) {
      console.log(100);
    },
  },
};
